//#region ../../packages/components/config-provider/src/constants.ts
const configProviderContextKey = Symbol();

//#endregion
export { configProviderContextKey };
//# sourceMappingURL=constants.mjs.map